import React from 'react';
import styles from './ReviewModal.module.scss';
import Modal from '@src/components/modal/Modal';
import Button from '@src/components/button/Button';
import { useCourseContent } from '@src/hooks';
import { Lesson } from '@src/types';

type Props = {
  open: boolean;
  onClose: () => void;
  onReviewLater: (lesson: Lesson) => void;
  onReviewNow: (lesson: Lesson) => void; 
};

function ReviewModal(props: Props) {
  const { open, onClose, onReviewLater, onReviewNow } = props;
  const { currentStudyplan, lesson } = useCourseContent();
  const handleReviewLater = () => {
    if (lesson) {
      onReviewLater(lesson)  
    }
  }
  const handleReviewNow = () => {
    if (lesson) {
      onReviewNow(lesson)
    }
  }
  return (
    <Modal global={false} open={open} onClose={onClose} className={styles.wrapper} closeOnOverlayClick={false}>
      <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.normalText}>Do you want {currentStudyplan?.name} to <strong>review</strong></div>
        <div className={styles.normalText}>this Lesson now?</div>
        <div className={styles.btnWrapper}>
          <Button label='Review Later' size='small' color='greenbackground' className={styles.yesButton} onClick={handleReviewLater} />
          <Button label='Review Now' size='small' className={styles.noButton} onClick={handleReviewNow} />
        </div>
      </div>
    </div>
    </Modal>
  );
}

export default ReviewModal;
